import axios from "axios";
const back_url = process.env.REACT_APP_BACKEND_URL;
const token = localStorage.getItem("token");
const apiClient = axios.create({
  baseURL: back_url,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;
export const submitFeedbackAction = async (payload: any) => {
  try {
    const response = await apiClient.post("/feedback/create_new", payload);
    if (response.data && response.data.status === "success") {
      return response.data; // This now correctly returns the user object
    } else {
      console.error("Feedback submit failed with status:", response);
      return response;
    }
  } catch (err) {
    console.error("Error during feedback submit :", err);
    throw err; // Optionally re-throw to handle the error in the component
  }
};

export const getFeedbackListAction = async () => {
  try {
    const response = await apiClient.get("/feedback/get_all");
    if (response.data && response.data.status === "success") {
      return response.data; // This now correctly returns the user object
    } else {
      console.error("Error fetching feedback list:", response);
      return response;
    }
  } catch (error) {
    console.error("Error fetching feedback list:", error);
  }
};
